export default "__VITE_ASSET__bd776b57__"